import { render, staticRenderFns } from "./RawModal.vue?vue&type=template&id=2ebc4670&scoped=true"
import script from "./RawModal.vue?vue&type=script&lang=js"
export * from "./RawModal.vue?vue&type=script&lang=js"
import style0 from "./RawModal.vue?vue&type=style&index=0&id=2ebc4670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc4670",
  null
  
)

export default component.exports